<template>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col p-col-12 p-md-12 p-lg-6" style="font-size: 16px">
      <Panel header="Thêm xe">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Tên chủ xe</label>
            <InputText id="name" type="text" v-model="carObject.name" style="text-align: center;font-size: 16px"/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Biển số xe</label>
            <InputText id="plate_number" type="text" v-model="carObject.plate_number" style="text-align: center;font-size: 16px"/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 16px">Thêm xe</label>
            <Button label="Thêm" icon="pi pi-plus-circle" iconPos="left" @click="createCar()" style="font-size: 16px"/>
          </div>
        </div>
      </Panel>
        </div>
        <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
      <Panel header="Danh sách xe">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
            <DataTable
                :loading="isLoading"
                :value="listCarObject" :paginator="true" stripedRows :rows="10"
                :rowsPerPageOptions="[10,25,50]" :rowHover="true"
                v-model:filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :globalFilterFields="['name']"
                currentPageReportTemplate="Có tổng số {totalRecords} xe" columnResizeMode="fit | expand">
              <template #header>
                <div class="p-d-flex p-jc-between p-ai-center">
                  <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 6em"/>
                  <span class="p-input-icon-left" style="width: 18em">
                    <i class="pi pi-search" />
                    <InputText v-model="filters['global'].value" placeholder="Tìm theo tên hoặc số điện thoại" />
                  </span>
                </div>
              </template>
              <Column field="name" header="Tên chủ xe" sortable></Column>
              <Column field="plate_number" header="Biển số xe" sortable style="font-weight: bold"></Column>
              <Column field="created_at" header="Ngày khởi tạo" sortable>
                <template #body="slotProps">
                  {{formatDateTime(slotProps.data.created_at)}}
                </template>
              </Column>
              <Column header="Chỉnh sửa">
                <template #body="slotProps">
                    <Button class="p-button-danger" label="Xoá" icon="pi pi-trash" @click="deleteCar(slotProps.data.id)">
                    </Button>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script lang="ts">

import moment from 'moment';
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import {ListCustomer} from "@/models/listCustomer";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {ManagerCheckinCreate} from "@/models/managerCheckinCreate";
import {ManagerCheckin} from "@/models/managerCheckin";
import {CarObject} from "@/models/carObject";

export default {

  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const listCarObject = ref([] as CarObject[]);
    const carObject = ref({} as CarObject);

    const loadListCar = () => {
      zaloRepository.getListCar()
          .then((response) => {
            listCarObject.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải danh sách xe',
              life: 2000
            });
          });
    }

    const deleteCar = (id) => {
      zaloRepository.deleteCar(id)
          .then((response) => {
            toast.add({
              severity: 'warn',
              summary: 'Thành công',
              detail:'Xe đã được xoá thành công khỏi hệ thống',
              life: 2000
            });
            loadListCar();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi xoá xe',
              life: 2000
            });
          });
    }

    const createCar = () => {
      zaloRepository.createCar(carObject.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail:'Thêm thành công xe vào danh sách',
              life: 2000
            });
            loadListCar();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi thêm xe',
              life: 2000
            });
          });
    }

    loadListCar();
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatDateTime = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    return {
      error,
      filters,
      clearFilter,
      initFilters,
      deleteCar,
      createCar,
      listCarObject,
      carObject,
      formatDateTime
    }
  }
}

</script>
